<template>
  <v-row class="align-stretch" justify="start" align-content="start">
    <v-col cols="12" sm="6" md="3">
      <SingleValueChart
          :title="$t('components.WebsitesPercentages.NumberAverageSessionDuration')"
          :info="$t('widgetsInfo.NumberAverageSessionDuration')"
          :data="stats.average_engagement_duration"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <SingleValueChart
          :title="$t('components.WebsitesPercentages.TotalUsers')"
          :info="$t('widgetsInfo.TotalUsers')"
          :data="stats.total_users"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <SingleValueChart
          :title="$t('components.WebsitesPercentages.TotalNewUsers')"
          :info="$t('widgetsInfo.TotalNewUsers')"
          :data="stats.total_new_users"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <SingleValueChart
          :title="$t('components.WebsitesPercentages.TotalEvents')"
          :info="$t('widgetsInfo.TotalEvents')"
          :data="stats.total_events"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
  </v-row>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';

/**
 * WebsitePercentages
 */
export default {
  name: 'WebsitePercentages',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    websitesData: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    stats: {
      average_engagement_duration: 0,
      total_users: 0,
      total_new_users: 0,
      total_events: 0
    }
  }),
  methods: {
    updateStats(data) {
      if (data){
        this.stats = data;
        this.stats.average_engagement_duration = parseFloat(data.average_engagement_duration).toFixed(1);
        //console.log(Math.round(parseFloat(data.average_engagement_duration)))
      } 
    }
  },
  watch: {
    websitesData(value) {
      this.updateStats(value);
    }
  },
  components: {SingleValueChart}
}
</script>